import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompany, fetchCompanyFilter, companyClear, companyFilterClear } from 'app/actions/CompanyActions';
import { getCompany, getCompanyFilter, getIsLoadingCompany } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function CompanyTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const { siteId } = useSelector(state => state.Auth);

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'clientName',
            key: 'clientName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idClient',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>

                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }

                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showTabEdit(record)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showTabEdit = (param) => {
        props.isVisibleForm(true);
        props.setIdClient(param.idClient);
        props.setNameClient(param.clientName);
    }

    const showConfirmDelete = (param) => {

        confirm({
            title: '¿Eliminar Compañía?',
            content: param.clientName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroCompany(props.FiltroCompany.filter(x => x !== param.clientName));
                return deleteClient(param);
            },
            onCancel() { },
        });
    }

    async function deleteClient(param) {
        await ApiService.deleteClient(param.idClient).then(res => {
            dispatch(companyFilterClear());
            dispatch(companyClear());
            dispatch(fetchCompanyFilter())
            dispatch(fetchCompany({
                clientName: props.FiltroCompany.filter(x => x !== param.clientName).join(','),
                sortColumn: column,
                sortDir: order,
                offset: offset,
                limit: limit
            }));
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let company = useSelector(getCompany);
    let companyFilter = useSelector(getCompanyFilter);

    let isLoading = useSelector(getIsLoadingCompany);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(company)) fetchCompanyAction();
        if (isEmpty(companyFilter)) fetchCompanyFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        dispatch(fetchCompany(
            {
                clientName: props.FiltroCompany.join('|'),
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && company.length > 0) {
            pagination.total = company[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchCompanyAction = () => dispatch(fetchCompany({
        clientName: props.FiltroCompany !== undefined ? props.FiltroCompany.join(',') : '',
        sortColumn: column,
        sortDir: order,
        offset: offset,
        limit: limit
    }));

    const fetchCompanyFilterAction = () => dispatch(fetchCompanyFilter())
    return (props.children({ pagination: pagination, cols: columns, company, companyFilter, isLoading, handleTableChange: handleTableChange }));
}

